<template lang="html">
    <b-table
        :data="data"
        default-sort-direction="asc"
        default-sort="title"
        sort-icon-size="is-small"
        :narrowed="true"
        :mobile-cards="false"
        class="watershed-characteristics-table"
    >
        <template slot-scope="props">
            <b-table-column
                field="icon"
                label=""
                class="icon-column"
                centered
            >
                <div
                    class="icon"
                    :style="{ 'background-color': props.row.color }"
                />
            </b-table-column>
            <b-table-column
                field="title"
                label="Type"
                sortable
            >
                {{ props.row.title }}
            </b-table-column>
            <b-table-column
                field="area"
                label="Area (km²)"
                sortable
                numeric
            >
                {{ props.row.area | numFormat('0,0.0') }}
            </b-table-column>
            <b-table-column
                field="percentage"
                label="% of Watershed"
                sortable
                numeric
            >
                {{ props.row.percentage | numFormat('0,0.0') }}%
            </b-table-column>
        </template>
    </b-table>
</template>

<script>

export default {
    props: {
        data: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style lang="scss">
.watershed-characteristics-table {
    font-size: 14px;

    td.icon-column {
        padding-top: 4px;

        .icon {
            width: 12px;
            height: 12px;
            border: 1px solid black;
            border-radius: 2px;
        }
    }
}
</style>
